export default __webpack_public_path__ + "static/media/tech-adoption-icon.933063bd.svg";